
class ImageSkeleton extends HTMLElement {
    #loadStartTime;
    #minimumRevealDelay;
    #revealInterval;
    #boundOnLoad;
    #image;
    connectedCallback() {
        if (this.hasAttribute("loaded")) return;
        this.#minimumRevealDelay = Number(this.getAttribute("minimum-reveal-delay") || 0);
        this.#revealInterval = null;
        this.#loadStartTime = Date.now();
        this.init();
    }
    disconnectedCallback() {
        if (this.#revealInterval) {
            clearInterval(this.#revealInterval);
            this.#revealInterval = null;
        }
        if (this.#image && this.#boundOnLoad) {
            this.#image.removeEventListener("load", this.#boundOnLoad);
        }
        this.removeAttribute("loaded");
        this.removeAttribute("aria-hidden");
    }
    init() {
        this.#image = this.nextElementSibling && this.nextElementSibling.tagName === "IMG" ? this.nextElementSibling : null;
        if (!this.#image) return;
        this.#boundOnLoad = () => {
            this.#revealInterval = setInterval((() => {
                if (Date.now() - this.#loadStartTime >= this.#minimumRevealDelay) {
                    clearInterval(this.#revealInterval);
                    setTimeout((() => {
                        this.markAsLoaded();
                    }), 250);
                }
            }), 50);
        };
        if (this.#image.hasAttribute("src") && this.#image.complete) {
            if (this.#minimumRevealDelay) {
                this.#boundOnLoad();
            } else {
                this.markAsLoaded();
            }
        } else {
            this.#image.addEventListener("load", this.#boundOnLoad);
        }
    }
    markAsLoaded() {
        this.setAttribute("loaded", "");
        this.setAttribute("aria-hidden", "true");
    }
}

customElements.define("image-skeleton", ImageSkeleton);
//# sourceMappingURL=image-skeleton.js.map
